import { t } from "ttag";

export interface MaxLengthParams {
  max: number;
}

export const requiredErrorMessage = () => t`Required`;
